export default class FilterManager {
  constructor({ onFilterChange } = {}) {

    this.filters = document.querySelector('.filters');
    this.nav = document.querySelector('header');
    this.originalParent = this.filters?.parentNode || null;
    this.originalNextSibling = this.filters?.nextSibling || null;
    this.changeHandler = this.onFilterChange.bind(this);
    this.onExternalChange = onFilterChange;
    this.valid = true;

    if (!this.nav || !this.filters) {
      this.valid = false;
      return;
    }

    this.mount();
  }

  mount() {
    this.nav.appendChild(this.filters);

    const inputs = this.filters.querySelectorAll('input[type="radio"][name="filter"]');
    inputs.forEach(input => {
      input.addEventListener('change', this.changeHandler);
    });

    const checked = this.filters.querySelector('input[type="radio"]:checked');
    if (checked) this.applyFilter(checked.value);
  }

  onFilterChange(e) {
    const val = e.target.value;
    this.applyFilter(val);
    if (this.onExternalChange) this.onExternalChange(val);
  }

  applyFilter(value) {
    const allItems = document.querySelectorAll('[data-filter]');
    this.headerHeight = (window.innerWidth * 0.22406);
    
    var top = (window.pageYOffset || document.scrollTop)  - (document.clientTop || 0);
    
    if(top > 3){
       window.scrollTo({ top: this.headerHeight });
    }
   

    allItems.forEach(el => {
      if (value === 'all-projects') {
        el.style.display = '';
      } else {
        el.style.display = el.classList.contains(value) ? '' : 'none';
      }
    });
  }

  destroy() {
    const inputs = this.filters.querySelectorAll('input[type="radio"][name="filter"]');
    
    inputs.forEach(input => {
      input.removeEventListener('change', this.changeHandler);
    });

    if (this.filters) {
      this.filters.parentNode.removeChild(this.filters);
    }
  }
}
